import { HR_ROUTES } from '../constants/routes';

export const HR_ROUTE_ACCESS = {
  [HR_ROUTES.REFERENCE_DATA]: { departments: ['HR', 'Executive'], roles: [] },
};

export const hrAccess = {
  id: 'hr',
  routes: HR_ROUTE_ACCESS,
  buttons: {},
};
